module.exports = __webpack_public_path__ + "static/media/1023680.a3b7dad3.png";